import { Action, createReducer, on } from '@ngrx/store';
import { IToolbarNotificationsResponse } from '../models/toolbar-notifications.model';

export const toolbarNotificationsFeatureKey = 'toolbarNotifications';
import * as actions from '../actions';

export interface ToolbarNotificationsState {
  loadToolbarNotificationsSuccess: IToolbarNotificationsResponse;
  loadToolbarNotificationsFailure: Error | any;
}

export const initialState: ToolbarNotificationsState = {
  loadToolbarNotificationsSuccess: undefined,
  loadToolbarNotificationsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadToolbarNotificationsSuccess, (state, action) => ({
    ...state,
    loadToolbarNotificationsSuccess: action.response
  })),
  on(actions.loadToolbarNotificationsFailure, (state, action) => ({
    ...state,
    loadToolbarNotificationsFailure: action.error
  }))
);

export const getToolbarNotifications = (state: ToolbarNotificationsState) => state.loadToolbarNotificationsSuccess;
